export default __webpack_public_path__ + "static/media/bfoundationlogo.1d5678dd.svg";